export const NUMBER_OF_PARTICIPATING_FRIENDS_TO_SHOW = 5
